import { PERSONAL_EMAIL_DOMAINS } from '@repo/contact-form-backend/src/lib/email-address/blocklist';

/**
 * Categorize this email as a personal email, disposable email, or work email
 */
export function isPersonalEmail(email: string): boolean {
  const split = email.split('@');
  const domain = split.at(-1);
  if (!domain) return false;
  const cleanDomain = domain.trim().toLowerCase();
  return PERSONAL_EMAIL_DOMAINS.has(cleanDomain);
}
